// client-web-appsuite/src/constants/prompt.js

let PROMPT = {
    // user and system prompt
    USER_DEFAULT: '',
    SYSTEM_DEFAULT: '',

    // length limits
    LENGTH_MAX: 16_384,
    LENGTH_VERBOSE: 1_024,
}

PROMPT = Object.freeze(PROMPT)

export default PROMPT